import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useInteracAutoDeposit() {
  const source = axios.CancelToken.source();
  const [autoDepositEnabled, setAutoDepositEnabled] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchAutoDepositStatus(emailAddress: string) {
    try {
      setLoading(true);
      const res = await api.fetchInteracAutoDepositStatus({ EmailAddress: emailAddress }, undefined, source);
      if (!res.Success) {
        setAutoDepositEnabled(false);
        throw new Error(res.ErrorMessage);
      }
      setAutoDepositEnabled(res.AutoDepositEnabled);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    autoDepositEnabled,
    fetchAutoDepositStatus,
  };
}
